var _defs, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsolvency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M4.92 37.56h13.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M25.47 16.4L17.64 26l-7.48-6.07 7.65-9.44M9.083 19.056l9.636 7.82-3.283 4.046-9.636-7.82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.44 13.13l-4.56-3.69 3.31-4.08 7.15 5.8 2.49 2.02-3.31 4.07-1.05-.85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M36.64 33.33L21.75 21.24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 23.18,
    cy: 37.56,
    r: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsolvency);
export default __webpack_public_path__ + "static/media/insolvency.80a3aac782d9d839bc468db4cd181b1e.svg";
export { ForwardRef as ReactComponent };